/* eslint-disable */

<template>
  <div>
    <vue-sortable :options="options" @drag:start="startedDrag" @drag:stop="stoppedDrag" @sortable:sort="sort">
      <div class="vx-row" :class="{ 'cursor-drag': draggingCard === true }">
        <div class="vx-col w-full">
          <vx-card class="mb-base px-0">
            <vue-draggable-container id="wordBank" class="wordBank">
              <h5 class="dragBlock font-semibold cursor-pointer" v-for="i in controls" :key="i">{{ i }}</h5>
            </vue-draggable-container>
          </vx-card>
        </div>
        <div class="vx-col w-full">
          <vx-card class="mb-base">
            <div class="p-0 px-4">
              <div class="vx-row mb-4">
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Question</h2>
                </div>
                <div class="vx-col w-1/2 flex items-center">
                  <h2 class="font-bold">Answer</h2>
                </div>
              </div>
              <div class="vx-row main-border bg-light items-center rounded-lg p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">
                    The DB server can only be managed from NIC3 via RDP from the sysadmin 10.100.2.0/24 network.
                  </h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input0">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row main-border bg-light items-center rounded-lg p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The web server in the 10.10.10.0/25 network should connect to the DB via NIC1</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input1">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row main-border bg-light items-center rounded-lg p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">
                    The backup server at 172.30.10.3 should perform DB backups by connecting via the 192.168.1.20/24 network.
                  </h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input2">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="vx-row main-border bg-light items-center rounded-lg p-4 my-6">
                <div class="vx-col w-1/2 flex items-center">
                  <h4 class="font-semibold">The DB server should not initiate outbound connections on NIC2</h4>
                </div>
                <div class="vx-col w-1/2">
                  <vue-draggable-container class="answerStandard dropzone dropzoneStandard answer-bg" id="input3">
                  </vue-draggable-container>
                </div>
              </div>
              <div class="flex items-center justify-center">
                <img
                  src="https://connect-cdn.intellectualpoint.com/assets/images/simulations/casp-plus/241518381319061504/graphic.png"
                  alt=""
                  draggable="false"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </vue-sortable>
  </div>
</template>

<script>
import draggable from 'vuedraggable';
import Prism from 'vue-prism-component';
import shuffle from 'shuffle-array';

export default {
  data() {
    return {
      dataLocal: JSON.parse(JSON.stringify(this.data)),
      draggingCard: false,

      controls: [
        'Permit UDP from 192.168.1.20 to 172.30.10.3',
        'Deny TCP from 10.0.10.20/24 to ANY',
        'Permit IP from 172.30.10.3 to 10.100.2.0',
        'Permit IP from 172.30.10.3 to 10.100.2.0',
        'Permit TCP from 10.100.2.0/24 to 172.16.0.20/24 port 1433',
        'Permit TCP from 172.16.0.20/32 to 10.10.10.0/25 port 1433',
        'Permit TCP from 10.100.2.0/24 to 172.16.0.20/32 port 3389',
        'Permit TCP from 10.10.10.0/24 to 192.168.1.20/24 port 1433',
        'Permit IP from 172.30.10.3 to 192.168.1.20',
        'Deny IP from 10.0.10.20 to ANY',
      ],

      options: {
        draggable: '.dragBlock',
        dropzone: '.dropzoneStandard',
      },
    };
  },
  methods: {
    startedDrag(x) {
      x.data.source.className += ' currently-dragging-standard';
      this.draggingCard = true;
    },
    stoppedDrag() {
      this.draggingCard = false;
    },
    sort(x) {
      const overContainer = x.data.dragEvent.data.overContainer;
      const sourceContainer = x.data.dragEvent.data.sourceContainer;
      if (overContainer && overContainer.id !== 'wordBank' && overContainer.children) {
        if (overContainer.children.length > 0 && overContainer.id !== sourceContainer.id) {
          //this.drag_error()
          x.cancel();
        }
      }
    },
    markSimulation() {
      let totalScore = 0;

      if (document.getElementById('input0').textContent === 'Permit TCP from 10.100.2.0/24 to 172.16.0.20/32 port 3389') {
        document.getElementById('input0').style.borderColor = '#28C76F';
        document.getElementById('input0').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input0').style.borderColor = '#fd4445';
        document.getElementById('input0').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input1').textContent === 'Permit TCP from 10.10.10.0/24 to 192.168.1.20/24 port 1433') {
        document.getElementById('input1').style.borderColor = '#28C76F';
        document.getElementById('input1').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input1').style.borderColor = '#fd4445';
        document.getElementById('input1').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input2').textContent === 'Permit IP from 172.30.10.3 to 192.168.1.20') {
        document.getElementById('input2').style.borderColor = '#28C76F';
        document.getElementById('input2').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input2').style.borderColor = '#fd4445';
        document.getElementById('input2').style.backgroundColor = '#fd4445';
      }

      if (document.getElementById('input3').textContent === 'Deny IP from 10.0.10.20 to ANY') {
        document.getElementById('input3').style.borderColor = '#28C76F';
        document.getElementById('input3').style.backgroundColor = '#28C76F';
        totalScore++;
      } else {
        document.getElementById('input3').style.borderColor = '#fd4445';
        document.getElementById('input3').style.backgroundColor = '#fd4445';
      }

      if (totalScore === this.dataLocal.simulation.totalScore) {
        return this.$emit('simulation_full_correct', totalScore);
      }

      this.$emit('simulation_getting_there', totalScore);
    },
  },
  components: {
    draggable,
    Prism,
    shuffle,
  },
  created() {
    this.controls = shuffle(this.controls);
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
#wordBank {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.8rem;
  flex-wrap: wrap;
}
</style>
